import React, { Component, } from 'react'
import { Bar, BarChart, Label, Legend, Tooltip, XAxis, YAxis } from 'recharts';
import { COLORS } from '../../utils/colors';
import styles from '../../index.scss';

const getIntroOfPage = (label) => {
    if (label === 'interstitial_load_amount') {
      return "Created when a full screen advertisemnt is displayed";
    }
    if (label === 'interstitial_click_amount') {
      return "Created when a full screen advertisemnt is clicked";
    }
    if (label === 'banner_load_amount') {
      return "Created when a advertisemnt banner is displayed";
    }
    if (label === 'banner_click_amount') {
      return 'Created when a advertisemnt banner is clicked';
    }
    return '';
};

const getColors = (label) => {
    if (label === 'interstitial_load_amount') {
      return COLORS.lightBlue;
    }
    if (label === 'interstitial_click_amount') {
        return COLORS.blue;
    }
    if (label === 'banner_load_amount') {
        return COLORS.lightGreen;
    }
    if (label === 'banner_click_amount') {
        return COLORS.green;
    }
    return null;
};

class AdvertisementLogBarChart extends Component {
  state = {
    error: "",
    tooltip: null,
    tooltipLabel: null,
    tooltipPosition: {
        x: 0,
        y: 0
    }
  }

   
  render() {    

    const handleMouseMove = (e) => {
      this.setState({
        tooltipPosition: {
            x: e.chartX - styles.tooltipWidth/2,
            y: e.chartY - styles.tooltipHeight/1.75
        }
      })
    };
    const CustomBar = (name) => {
        return (
            <Bar 
              name={name} 
              dataKey={`advertisement_log.${name}`} 
              fill={ getColors(name) }
              minPointSize={1}
              onMouseOver={(data) =>{
                  this.setState({
                      tooltipLabel: name,
                      tooltip: data.advertisement_log[name],
                      user: data
                  })
              }}
            />
        );
    }
    const CustomTooltip = ({ active}) => {
        if (active && this.state.tooltip) {
        return (
            <div className="custom-tooltip">
                <p className="label">{`${this.state.tooltipLabel} : ${this.state.tooltip}`}</p>
                <p>{getIntroOfPage(this.state.tooltipLabel)}</p>
                <p>{this.state.user?.fullname}</p>
                <p>{this.state.user?.email}</p>
            </div>
        );
        }
    
        return null;
    };
    const users = this.props.users;
    
    let maxValue = 0
    users.forEach((value) => {
        function isBigger(amount) {
            if(amount > maxValue) {
                maxValue = amount
            }
        }
        isBigger(value.advertisement_log.interstitial_load_amount)
        isBigger(value.advertisement_log.interstitial_click_amount)
        isBigger(value.advertisement_log.banner_load_amount)
        isBigger(value.advertisement_log.banner_click_amount)
    })
    
    const tickValues = Array.from({length: Math.ceil(maxValue / 5) + 1}, (_, i) => i * 5);
    tickValues.unshift(0)
    tickValues[1] = 1
    
    return (
        <div>
            <BarChart width={1200} height={600} data={users} onMouseMove={handleMouseMove}
              margin={{ top: 20, right: 30, left: 20, bottom: 30 }}>
                <XAxis dataKey="id">
                  <Label value="User ID" position="bottom" dy={-10}/>
                </XAxis>
                <YAxis type="number" domain={[0, maxValue * 1.2]} tickCount={tickValues.length} ticks={tickValues}>
                  <Label value="Call amount" 
                  angle={-90} 
                  position="left" 
                  dy={-10} />
                </YAxis>
                <Legend 
                  layout="vertical" 
                  verticalAlign="top" 
                  align="right" 
                  wrapperStyle={{ padding: '10px' }}/>
                <Tooltip content={<CustomTooltip/>} cursor={false} allowEscapeViewBox={{x:true, y:true}} position={this.state.tooltipPosition}/>
                {CustomBar("interstitial_load_amount")}
                {CustomBar("interstitial_click_amount")}
                {CustomBar("banner_load_amount")}
                {CustomBar("banner_click_amount")}
            </BarChart>
        </div>
    )
  }
}

export default AdvertisementLogBarChart